import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { BRAND } from "@/lib/brand";

export default function Hero() {
  const { t } = useI18n();
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex flex-col overflow-hidden bg-[#fdfcf9]">
      {/* Background video */}
      <div className="absolute inset-0 bg-[#1c2421]">
        <video
          src={BRAND.logoVideoUrl}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="w-full h-full object-contain sm:object-cover"
          data-testid="hero-video"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#3e664c]/30 via-[#1c2421]/35 to-[#1c2421]/85" />
      </div>

      {/* Eyebrow positioned at top so it doesn't overlap the video logo */}
      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 pt-28 md:pt-32">
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-[#fdfcf9]/90 text-[10px] md:text-xs uppercase tracking-[0.4em] font-medium"
          data-testid="hero-eyebrow"
        >
          {t.hero.eyebrow}
        </motion.p>
      </div>

      {/* CTAs at bottom */}
      <div className="relative flex-1 flex items-end w-full max-w-7xl mx-auto px-6 md:px-12 pb-12 md:pb-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-wrap items-center gap-4"
        >
          <a
            href="#disponibilidad"
            data-testid="hero-cta-calendar"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#3e664c] text-[#fdfcf9] hover:bg-[#2e5949] transition-colors text-sm uppercase tracking-[0.18em] font-medium"
          >
            {t.hero.ctaCalendar}
            <span className="text-lg">→</span>
          </a>
          <a
            href="#eventos"
            data-testid="hero-cta-events"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full border border-[#fdfcf9]/40 text-[#fdfcf9] hover:bg-[#fdfcf9]/10 transition-colors text-sm uppercase tracking-[0.18em] font-medium"
          >
            {t.hero.ctaEvents}
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-6 right-6 md:right-12 text-[#fdfcf9]/60 text-xs tracking-[0.3em] uppercase rotate-90 origin-bottom-right hidden md:block"
      >
        scroll
      </motion.div>
    </section>
  );
}
